import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class NotificationService {
    notify: Subject<any[]> = new Subject<any[]>();

    broadcast(event) {
        this.notify.next(event);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/notification.service.ts